import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResDocumentOCRListQuery } from './types'

export const documentOCRListQuery = (jobId?: number) =>
  queryOptions<ResDocumentOCRListQuery, unknown>({
    queryKey: [API_ENDPOINTS.business.v1.ocr.task.index, jobId],
    queryFn: () => w.get(`${API_ENDPOINTS.business.v1.ocr.task.index}/${jobId}`).json(),
    enabled: typeof jobId === 'number',
  })
